export const cegidEkonConfiguration = {
  cegid_ekon_configurations: "Cegid Ekon Configurations",
};
